import { useState, Suspense } from "react"
import MatchDetailsAudit from "./MatchDetailsAudit.jsx"
import { colorizeBgPoints } from '../ExplainPoints.jsx'
import { Tooltip } from 'react-tooltip'

export default function MatchDetailsEnded({groupId, match, bet}) {
  const [showGuesses, setShowGuesses] = useState(false)
  const toggleShowGuesses = () => {
    setShowGuesses(!showGuesses)
  }
  const bgColor = bet.id === null ? 'bg-gray-500' : colorizeBgPoints(bet.points)
  const textGuess = bet.id === null ? 'Você não palpitou' : `Seu palpite: ${bet.guess_score_team_a} x ${bet.guess_score_team_b} fez ${bet.points} pts`

  return (
    <>
      <div className="flex flex-col rounded-b-lg text-sm mx-auto w-full">
        <div className={`text-center text-white ${!showGuesses ? "rounded-b-lg" : ""} w-full px-3 py-1 cursor-pointer underline hover:no-underline ${bgColor}`} onClick={() => toggleShowGuesses()}>
          <span id={`audit-match-${groupId}-${match.id}`}>{textGuess}</span>
          <Tooltip anchorSelect={`#audit-match-${groupId}-${match.id}`} place="top" type="dark" effect="float">
            {`${showGuesses ? "Ocultar" : "Ver todos os"} palpites`}
          </Tooltip>
        </div>
      </div>
      {showGuesses === true && (
        <div className="text-center w-full rounded-b-lg">
          <Suspense fallback={<p>Carregando...</p>}>
            <MatchDetailsAudit groupId={groupId} match={match} bet={bet} standingsAuditMatchPage={1} OnToggleShowGuessesClick={toggleShowGuesses} />
          </Suspense>
        </div>
      )}
    </>
  )
}
